<template>
	<div class='invoice-details'>

		<h6 class='sub-header primary-color'>{{getText('InvoiceDetails')}}</h6>

		<div class="general-note" style="">
			{{getText('InvoiceDetailsHint')}}
		</div>

		<!-- First row: Invoice Details -->
		<div class="row">

            <div class='col-lg-6'>
                <div class='invoice-title'><b>{{getText('InvoiceId')}}</b></div>
                <div class='invoice-data' :class='text_length'>{{invoice().id}}</div>
            </div>
            <div class='col-lg-6'>
                <div class='invoice-title'><b>{{getText("AmountPayable")}}</b></div> 
                <div class='invoice-data'>
                    {{rateOffer().Symbol}} {{getAmountPayable(invoice(), rateOffer().RateOffer)}}
                    <div class='tight-merchant-flag'>
						<div class='currency-text'>
							<img class='flag' v-if='rateOffer().Country != ""' :src='"https://st.rch.io/flags/"+rateOffer().Country+".png"' />
							<span class='flag-text' v-if='rateOffer().RateOffer !== undefined'>{{rateOffer().Currency}}</span>
						</div>
					</div>
                </div>
            </div>

			<div class='col-sm-12 mt-1' v-if='merchant().ShowMerchantCurrency'>
                <div class='invoice-data tiny'>
                    1 {{merchant_currency().currency}} = {{rateOffer().RateOffer.Rate}} {{rateOffer().Currency}}
                </div>
				<div class='invoice-title tiny'><b>{{getText('ExchangeRate')}}</b></div> 
            </div>
		</div>
		

	</div>
</template>

<script>

import { mapGetters } from "vuex";

import FormInput from "@/components/form_elements/FormInput"
import FormNumber from "@/components/form_elements/FormNumber"
import FormSelect from "@/components/form_elements/FormSelect"

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "PresetInvoiceDetails",
	components: {
		FormInput,
		FormNumber,
		FormSelect
	},
	props: {
		currencies: Array
	},
	computed: {
        text_length(){
            if(this.invoice().id.length > 25) return 'long-text';
            else if(this.invoice().id.length > 15) return 'medium-text';
            else return 'short-text';
        },
		currency_option_list(){
			return this.currencies.map( x => ({ id: x.id, value: x.id+" - "+x.value}));
		},
		country_list(){
			// Grab and format available countries
			return this.available_countries().map(
					x => ({ id: x.code, value: x.name})
				);
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
    getAmountPayable(invoice, rateOffer){
      let amountPayable;
      if(!invoice.amount_payable){
        amountPayable = (invoice.amount * rateOffer.Rate).toFixed(rateOffer.Units) || "--"
      }else{
        amountPayable = parseFloat(invoice.amount_payable).toFixed(rateOffer.Units);
      }
      return amountPayable;
    },
		...mapGetters(["merchant", "merchant_currency","invoice", "invoice_editable", "rateOffer", "available_countries", "rates"])
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

    .long-text{
        font-size: 1rem !important;
		padding: 19px 0px !important;
    }
    .medium-text{
        font-size: 1.35rem !important;
		padding: 15px 0px !important;
    }
    .short-text{
        font-size: 1.75rem !important;
    }
    .invoice-title{
        border: 1px solid #CDCDCD;
        border-bottom: 0px;
        text-align: center;
        background-color: #EBEBEB;
        padding: 3px 0px;

		&.tiny{
			padding: 0px 0px 2px;
			font-size: 0.8rem;
			border-bottom: 1px solid #CDCDCD;
			border-top-width: 0px;
			background-color: transparent;
			border: 0px;
		}
    }
    .invoice-data{
        border: 1px solid #CDCDCD;
        text-align: center;
        font-size: 1.75rem;
        padding: 10px 0px;

		&.tiny{
			border: 0px;
			font-size: 1rem;
			border-bottom: 0px; 
			padding-bottom: 0px;
		}
    }
	.tight-merchant-flag{

		position: relative;
        display: inline-block;
		bottom: 4px;
        right: 0px;
		z-index: 999;
        margin-left: 5px;

		.currency-text{
			position: relative;
            padding-left: 36px;

			.flag{
				left: 0px;
				top:2px;
			}

			.flag-text{
				position: relative;
				top: 2px;
			}
		}
	}
	label{
		width: 100%;
		margin-top: 20px;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
	}
	.general-note{
		margin-bottom: 20px;
	}
	.flag{
		position: absolute;
		top: 10px;
		height: 24px;
	}
	.currency-block{
		padding: 8px 13px 6px 12px;
		background: rgba(205, 205, 205, 0.4);
		position: relative;
		border-radius: 5px;
		color: #747C84;

		.merchant-flag{
			right: 10px;
		}
	}
	.country-flag{
		position: absolute;
		top: auto;
		right: 10px;
	}
	.currency-text{
		display: inline-block;
		font-size: 20px;
		width: 100%;
		padding-left: 40px;

		&.no-flag{
			padding-left: 0px;
		}
	}
	.ex-rate{
		font-size: 0.7em;
		position: absolute;
		bottom: -18px;
		left: 5px;
	}
	.country-block{
		position: relative;

		.flag{
			top: auto;
			bottom: 12px;
			right: 35px;
		}

	}
</style>
